import { Image } from './../../../../../shared/sdk/models/Image';
import { SeCommonConfig } from './../SeCommonConfig.class';
import { IBaseSEConfig } from '../base-se-config.interface';
import * as _ from 'lodash';

export class SeImageConfig extends SeCommonConfig implements IBaseSEConfig {
  // settings just for this element
  public imageURL = '';
  public SeType = 'SeImage';
  public modelRef: Image;

  constructor(jsonString?: string) {
    super();
    if (jsonString) {
      this.fromJsonString(jsonString);
    }
  }

  // create json from class vars
  toJson() {
    const obj = super.toJson(); // process common base config settings
    obj.imageURL = this.imageURL; // and any custom props
    obj.SeType = this.SeType;
    obj.modelRef = this.modelRef;

    obj.files = [];
    if (obj.modelRef) {
      obj.files.push({
        libraryId: this.modelRef.libraryId,
        fileName: this.modelRef.FilenameOnServer,
        hash: this.modelRef.hash
      });
    }

    return obj;
  }

  // parse json to class vars
  fromJson(obj) {
    super.fromJson(obj); // process common base config settings
    this.imageURL = _.get(obj, 'imageURL', ''); // get val in safe way with defalut
    this.SeType = _.get(obj, 'SeType', 'SeImage');
    this.modelRef = _.get(obj, 'modelRef', null);

    // override some props that werer filled in by super call
    this.sizeInBytes = _.get(obj, 'modelRef.FileSize', 0);

    this.files = [];
    if (this.modelRef) {
      this.files.push({
        libraryId: this.modelRef.libraryId,
        fileName: this.modelRef.FilenameOnServer,
        hash: this.modelRef.hash
      });
    }

  }

  toJsonString() {
    return JSON.stringify(this.toJson());
  }

  fromJsonString(str) {
    this.fromJson(JSON.parse(str));
  }


}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-image/se-image-config.class.ts